import { observable, computed, action } from 'mobx';
import { app } from './../App';
import { Lead } from '.';
import {
  ILeadResource,
  ILeadResourcesApi,
  IUploadFiles,
  UploadStatus,
} from 'common/interfaces/resources';

// Store
export class LeadResources {
  constructor(private lead: Lead) {}

  @observable public loading: boolean = false;
  @observable public all: ILeadResource[] = [];
  @computed public get allIds(): number[] {
    return this.all.map((resource) => resource.id);
  }

  @observable public editing: boolean = false;

  @observable public uploadFiles: IUploadFiles = {
    files: null,
    status: UploadStatus.None,
  };

  @action public startEditing = () => {
    this.editing = true;
  };

  @action public stopEditing = () => {
    this.editing = false;
  };

  @action public fetchLeadResources = async (
    providerId?: number
  ): Promise<any> => {
    try {
      this.loading = true;

      const service = app.service('provider-file');
      const files: ILeadResourcesApi = await service.find({
        query: {
          providerId:
            typeof providerId !== 'undefined'
              ? providerId
              : this.lead.openLeadId,
          $sort: {
            updatedAt: 1,
          },
        },
      });

      this.all = files.data;

      return files;
    } catch (err) {
      this.all = [];
      console.error(err);
      return err;
    } finally {
      this.loading = false;
    }
  };

  @action public uploadLeadResources = async (): Promise<any> => {
    try {
      const service = await app.service('provider-file-upload');

      this.uploadFiles.status = UploadStatus.Saving;

      const files = this.uploadFiles.files;
      const filesCount = files.length;
      const parsedFiles: Array<{ data: string; name: string }> = [];
      let parsedFilesCount: number = 0;

      const reader = new FileReader();

      const resolve = async () => {
        for (let i = 0; i < parsedFilesCount; i++) {
          const upload = await service.create({
            uri: parsedFiles[i].data,
            providerId: this.lead.openLeadId,
            fileName: parsedFiles[i].name,
          });
        }

        this.uploadFiles.status = UploadStatus.None;
        this.uploadFiles.files = null;
        this.fetchLeadResources();
        return true;
      };

      reader.onloadend = () => {
        parsedFiles.push({
          data: reader.result as string,
          name: files[parsedFilesCount].name,
        });
        parsedFilesCount++;
        if (parsedFilesCount < filesCount) {
          reader.readAsDataURL(files[parsedFilesCount]);
        } else {
          resolve();
        }
      };

      reader.readAsDataURL(files[0]);
    } catch (err) {
      this.uploadFiles.status = UploadStatus.Error;
      this.uploadFiles.files = null;
      console.error(err);
      return err;
    }
  };

  @action public handleUploadFilesChange = (files: FileList) => {
    this.uploadFiles.files = files;
    this.uploadLeadResources();
  };

  @action public removeLeadResource = async (id: number): Promise<any> => {
    try {
      const service = app.service('provider-file');
      const removal = await service.remove(id);

      if (this.all.length <= 1) {
        this.all = [];
        this.editing = false;
      } else {
        const indexOfResource = this.allIds.indexOf(id);
        if (indexOfResource !== -1) {
          this.all = this.all
            .slice(0, indexOfResource)
            .concat(this.all.slice(indexOfResource + 1));
        }
      }

      return removal;
    } catch (err) {
      console.error(err);
      return err;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/LeadResources.ts